import { Select } from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import { Frequency } from '../../../../store/calculator/financial';
import { getTranslations } from '../../../../translations';

interface WeeklyFreequencyInterface {
    frequencyHandler : Function
}

const WeeklyFrequency = ({frequencyHandler} : WeeklyFreequencyInterface) => {

    const trans = getTranslations();

    const frequencies : Frequency[] = getTranslations().details.calculator.frequencies;

    const weeklyFrequencyHandler = (event: React.SyntheticEvent<HTMLSelectElement, Event>) => {
        const value = (event.target as HTMLFormElement).value;

        const frequency = frequencies.filter(frequency => frequency.value == value).reduce(frequency => frequency);
        frequencyHandler(frequency);
    }

    useEffect(() => {
        frequencyHandler(frequencies[0]);
    }, []);

    return (
        <Select label={trans.details.calculator.payment_financeFrequency} defaultValue="1" onChange={(e) => weeklyFrequencyHandler(e)}>
            {frequencies && frequencies.map((frequency) => {
                return <option value={frequency.value} key={frequency.value}>{frequency.text}</option>
            })}
        </Select>
    );
}

export default WeeklyFrequency;
